import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useCallback, useState } from 'react';
import { Helmet } from 'react-helmet';

var PageMetaTags = function PageMetaTags(_ref) {
  var title = _ref.title,
      description = _ref.description,
      children = _ref.children;

  var _useState = useState(title),
      _useState2 = _slicedToArray(_useState, 2),
      realTitle = _useState2[0],
      setRealTitle = _useState2[1];
  /**
   * Helmet use titleTemplate for create real title, but we can't get.
   *
   * This callback need for get real title after calculate by Helmet
   */


  var handleChangeRealTitle = useCallback(function (data) {
    if (data && data.title) {
      setRealTitle(data.title);
    }
  }, [setRealTitle]);
  return /*#__PURE__*/React.createElement(Helmet, {
    onChangeClientState: handleChangeRealTitle
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("meta", {
    property: "og:title",
    content: realTitle
  }), /*#__PURE__*/React.createElement("meta", {
    property: "twitter:title",
    content: realTitle
  }), !!description && /*#__PURE__*/React.createElement("meta", {
    name: "description",
    content: description
  }), !!description && /*#__PURE__*/React.createElement("meta", {
    property: "og:description",
    content: description
  }), !!description && /*#__PURE__*/React.createElement("meta", {
    property: "twitter:description",
    content: description
  }), children);
};

export default PageMetaTags;